export default __webpack_public_path__ + "static/desk-a6587fa34d550180964dbbde67432b0b.jpg";